export default [
  {
    'label': 'Heart only',
    'value': 'single'
  },
  {
    'label': 'Multiple organs',
    'value': 'multi'
  }
]



// WEBPACK FOOTER //
// ./src/options/organ-modes.js